// extracted by mini-css-extract-plugin
module.exports = {"changeTagsModal":"ChangeTagsModal_changeTagsModal__2hme0"};